"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _useRecommendationStatus = require("../../hooks/recommendation/useRecommendationStatus");
var _ErrorHeader = _interopRequireDefault(require("../Error/ErrorHeader"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const RecommendationErrorPageHeaderFactory = () => {
  const {
    isJourneyForObject
  } = (0, _useRecommendationStatus.useRecommendationStatus)();
  switch (true) {
    case isJourneyForObject.isJourneyForHandset:
      return null;
    case isJourneyForObject.isJourneyForHandsetAndPlan:
      return null;
    case isJourneyForObject.isJourneyForPlan:
      return null;
    case isJourneyForObject.isJourneyForBroadband:
      return /*#__PURE__*/_react.default.createElement(_ErrorHeader.default, null);
    default:
      return null;
  }
};
var _default = RecommendationErrorPageHeaderFactory;
exports.default = _default;